// extracted by mini-css-extract-plugin
module.exports = {"container":"Dock_container__2dYmK","dockItem":"Dock_dockItem__f1Eip","prev":"Dock_prev__1fXYF"};